import { render, staticRenderFns } from "./DevSwitchPlanList.vue?vue&type=template&id=fad31c2e&scoped=true&"
import script from "./DevSwitchPlanList.vue?vue&type=script&lang=js&"
export * from "./DevSwitchPlanList.vue?vue&type=script&lang=js&"
import style0 from "./DevSwitchPlanList.vue?vue&type=style&index=0&id=fad31c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad31c2e",
  null
  
)

export default component.exports